import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500">热门预告片与精彩片段抢先看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-600 text-xl md:text-2xl ml-0.5 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1 line-clamp-1">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}